import { z } from 'zod';
import { interactionFeedSearchSchema } from '../../interactions';

export const praiseFeedSearchSchema = interactionFeedSearchSchema.extend({
  coreValues: z.array(z.string()).catch([]),
  frameworks: z.array(z.string()).catch([]),
});

export type PraiseFeedSearch = z.infer<typeof praiseFeedSearchSchema>;
